// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"94":"f21f7358","496":"965cc9a3","547":"8bc06119","794":"e9545732","832":"d152610f","914":"4cee21ed"}[chunkId] + ".css";
};